import { Search, X } from 'lucide-react'
import { TextField } from '../Input/TextField'
import { clearButton } from './SearchField.css'

export type SearchFieldProps = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  ariaLabel?: string
}

export function SearchField({ value, onChange, placeholder, ariaLabel }: SearchFieldProps) {
  return (
    <TextField
      type="search"
      value={value}
      placeholder={placeholder}
      aria-label={ariaLabel}
      onChange={(event) => onChange(event.target.value)}
      leftIcon={<Search size={16} aria-hidden />}
      rightSlot={
        value ? (
          <button
            type="button"
            className={clearButton}
            aria-label="Limpar busca"
            onClick={() => onChange('')}
          >
            <X size={16} aria-hidden />
          </button>
        ) : null
      }
    />
  )
}
